import styled from '@emotion/styled'

export const Timeslot = styled.div<{colorContrast: string | undefined, zoomLevelValueCalc: number}>`
   background-color: ${({ colorContrast }) => colorContrast};
    border-bottom: 1px solid #b3b3b3;
  border-right: 1px solid #b3b3b3;
  height: ${({ zoomLevelValueCalc }) => (`${zoomLevelValueCalc}px`)};
  width: 40px;
`

export const TimeLineWrapper = styled.div`
    pointer-events: none;
    position: absolute;
    width: 100%;
    z-index: 1;
`

export const TimeLine = styled.hr`
    border: 0.2px solid #005cd9;
`

export const Time = styled.p`
    color: #005cd9
`
